export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20on%20minimalist%20marble%20surface%20with%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20tones%2C%20high-end%20fashion%20editorial%20style%2C%20subtle%20shadows%20and%20elegant%20composition&width=300&height=200&seq=cat-shoes-v2&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20beige%20hoodie%20styled%20on%20minimalist%20wooden%20hanger%20against%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20streetwear%20product%20photography%2C%20editorial%20fashion%20aesthetic%20with%20gentle%20shadows&width=300&height=200&seq=cat-hoodies-v2&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20black%20cotton%20t-shirt%20flat%20lay%20on%20warm%20linen%20surface%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20neutral%20earth%20tones%2C%20editorial%20style%20composition%20with%20subtle%20texture%20details&width=300&height=200&seq=cat-tshirts-v2&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-honour-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20draped%20on%20minimalist%20chair%20against%20warm%20beige%20wall%2C%20soft%20natural%20lighting%2C%20clean%20fashion%20product%20photography%2C%20editorial%20aesthetic%20with%20gentle%20shadows%20and%20organic%20composition&width=300&height=200&seq=cat-jackets-v2&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Tailored%20navy%20chino%20pants%20neatly%20folded%20on%20warm%20wooden%20surface%2C%20minimalist%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20neutral%20earth%20tones%20and%20subtle%20textile%20texture&width=300&height=200&seq=cat-pants-v2&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
    image: 'https://readdy.ai/api/search-image?query=Classic%20white%20baseball%20cap%20on%20minimalist%20concrete%20surface%20with%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20fashion%20aesthetic%20with%20gentle%20shadows%20and%20simple%20composition&width=300&height=200&seq=cat-headwear-v2&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20cream%20tracksuit%20set%20laid%20flat%20on%20warm%20linen%20background%2C%20coordinated%20hoodie%20and%20joggers%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20fashion%20aesthetic%20with%20minimalist%20composition&width=300&height=200&seq=cat-sets-v2&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20black%20boxer%20briefs%20neatly%20folded%20on%20warm%20marble%20surface%2C%20minimalist%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20neutral%20warm%20tones%20and%20subtle%20fabric%20texture%20details&width=300&height=200&seq=cat-underwear-v2&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    image: 'https://readdy.ai/api/search-image?query=Classic%20red%20football%20jersey%20hanging%20on%20minimalist%20wooden%20hanger%20against%20warm%20cream%20background%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20sports%20fashion%20aesthetic%20with%20gentle%20shadows&width=300&height=200&seq=cat-jersey-v2&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20gold%20chain%20necklace%20and%20minimalist%20watch%20arranged%20on%20warm%20beige%20marble%20surface%2C%20luxury%20accessories%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20editorial%20style%20and%20subtle%20shadows&width=300&height=200&seq=cat-accessories-v2&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Tan%20leather%20crossbody%20bag%20on%20minimalist%20wooden%20surface%20with%20soft%20natural%20lighting%2C%20clean%20fashion%20product%20photography%2C%20warm%20neutral%20tones%2C%20editorial%20aesthetic%20with%20gentle%20shadows%20and%20elegant%20composition&width=300&height=200&seq=cat-bags-v2&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    image: 'https://readdy.ai/api/search-image?query=Classic%20brown%20leather%20belt%20with%20brass%20buckle%20on%20warm%20linen%20surface%2C%20minimalist%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20neutral%20earth%20tones%20and%20subtle%20leather%20texture&width=300&height=200&seq=cat-belts-v2&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20on%20warm%20marble%20surface%20with%20soft%20natural%20lighting%2C%20luxury%20beauty%20product%20photography%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones%20and%20gentle%20shadows&width=300&height=200&seq=cat-perfumes-v2&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20lifestyle%20products%20including%20sunglasses%20notebook%20and%20keychain%20on%20warm%20wooden%20surface%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20aesthetic%20with%20neutral%20earth%20tones%20and%20minimalist%20composition&width=300&height=200&seq=cat-other-v2&orientation=landscape',
  },
];

export const features = [
  {
    title: 'Save Time',
    description: 'Find thousands of products without endless searching across multiple marketplaces.',
    icon: 'ri-time-line',
  },
  {
    title: 'Better Product Research',
    description: 'Compare different options side by side before making purchasing decisions.',
    icon: 'ri-search-eye-line',
  },
  {
    title: 'Beginner Friendly',
    description: 'Learn how Sugargoo shopping works with clear, step-by-step guidance.',
    icon: 'ri-user-smile-line',
  },
  {
    title: 'Safer Shopping',
    description: 'Understand QC photos, shipping processes and warehouse operations before you buy.',
    icon: 'ri-shield-check-line',
  },
];

export const reviewPros = [
  'Extensive product sourcing from multiple marketplaces',
  'Reliable warehouse service with QC photo inspection',
  'Multiple international shipping options available',
  'User-friendly platform with clear order tracking',
  'Competitive service fees compared to alternatives',
];

export const reviewCons = [
  'Shipping costs can vary significantly by destination',
  'Learning curve for first-time agent service users',
  'Delivery times depend on shipping method chosen',
];

export const shippingMethods = [
  { method: 'EMS', speed: '7-15 days', cost: 'Moderate', bestFor: 'Balanced speed and cost' },
  { method: 'DHL/FedEx', speed: '3-7 days', cost: 'Higher', bestFor: 'Fast delivery priority' },
  { method: 'EUB/ePacket', speed: '10-25 days', cost: 'Lower', bestFor: 'Budget-conscious shipping' },
  { method: 'SAL', speed: '15-30 days', cost: 'Lowest', bestFor: 'Maximum savings, no urgency' },
  { method: 'Sea Freight', speed: '30-60 days', cost: 'Bulk savings', bestFor: 'Large volume shipments' },
];

export const faqs = [
  {
    question: 'What is a Sugargoo Spreadsheet?',
    answer: 'A Sugargoo Spreadsheet is an organized product discovery system that compiles product listings, prices, quality notes, and shopping tips into a structured format. It helps shoppers quickly find and compare products from various marketplaces without spending hours searching manually.',
  },
  {
    question: 'Is Sugargoo safe to use?',
    answer: 'Sugargoo is a widely used shopping agent platform. They offer warehouse inspection services, QC photos, and buyer protection. While no service is completely risk-free, Sugargoo has established processes to help protect buyers throughout the shopping and shipping journey.',
  },
  {
    question: 'How does Sugargoo warehouse work?',
    answer: 'When you order products through Sugargoo, items are first shipped to their warehouse. Staff inspect items, take QC photos, and store them. You can then choose to ship items individually or consolidate multiple items into one package to save on international shipping costs.',
  },
  {
    question: 'How much does Sugargoo shipping cost?',
    answer: 'Shipping costs depend on package weight, destination country, and shipping method. Typically, faster methods like DHL cost more, while economy options like EUB or SAL are more affordable. Consolidating multiple items can help reduce per-item shipping costs significantly.',
  },
  {
    question: 'Are there Sugargoo coupons or discount codes?',
    answer: 'Sugargoo occasionally offers promotional coupons and discount codes for shipping or service fees. These are typically announced on their platform or through partner channels. Checking their official announcements regularly is the best way to find active promotions.',
  },
  {
    question: 'How long does Sugargoo delivery take?',
    answer: 'Delivery time varies by shipping method. Express services like DHL take 3-7 days, EMS takes 7-15 days, while economy options like EUB can take 10-25 days. Sea freight is the slowest at 30-60 days but offers the best value for large shipments.',
  },
];